import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { AsidePage } from '~/features/imports/aside-page';

function AsideRoute(): ReactElement {
  const { importId } = Route.useParams();
  return <AsidePage importId={importId} />;
}

/** The rows an import set aside, on OS's page (board import-set-aside). */
export const Route = createFileRoute('/_app/coach/imports/$importId/aside')({ component: AsideRoute });
